module.exports = __webpack_public_path__ + "static/img/ind_ban_07.69037c06.jpeg";